export default __webpack_public_path__ + "static/media/slot-banners-cn.ab5ad905.webp";